/**
 * Created by Viacheslav Stepanian on 27.08.2026
 */

const WeeklyGoalsBar = function (pointsGoals) {
    return Prefab.instantiate(bundles.weekly_goals.jsons.weekly_goals_bar_prefab_json, { pointsGoals });
};
